import { render, staticRenderFns } from "./create_or_edit_form.vue?vue&type=template&id=4e46262e&lang=pug&"
import script from "./create_or_edit_form.vue?vue&type=script&lang=js&"
export * from "./create_or_edit_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports